import { inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { ConsumptionFilter, ConsumptionStore, getInitialFilter } from '../stores/consumption.store';
import { getFilterFromQueryParams } from '../pages/analysis-consumption-page/definitions';

export const consumptionLoadedGuard = (route: ActivatedRouteSnapshot) => {
  const consumptionStore = inject(ConsumptionStore);

  // initialize filter from query params
  const filter = getFilterFromQueryParams(route);
  if (!consumptionStore.get(filter)) {
    consumptionStore.load(filter);
  }

  return true;
};

/**
 * pre-load default consumption graph (both utility types)
 */
export const consumptionDashboardLoadedGuard = () => {
  const consumptionStore = inject(ConsumptionStore);

  const defaultFilter = getInitialFilter();
  if (!consumptionStore.get(defaultFilter)) {
    // fire & forget - let ui handle loading & error states
    consumptionStore.load(defaultFilter);
  }

  const alternateUtilityTypeFilter: ConsumptionFilter = {
    ...defaultFilter,
    data: {
      ...defaultFilter.data,
      utilityType: defaultFilter.data.utilityType === 'ELECTRICITY' ? 'GAS' : 'ELECTRICITY',
    },
  };
  if (!consumptionStore.get(alternateUtilityTypeFilter)) {
    // fire & forget - let ui handle loading & error states
    consumptionStore.load(alternateUtilityTypeFilter);
  }

  return true;
};
